import * as React from 'react';
import style from './MicrosoftLogo.module.scss';

import { Grid } from 'react-feather';



export const MicrosoftLogo = (props: {size?: number}) => (
    <Grid size={props.size} className={style['microsoft-logo']}/>
);